export interface PolicyItem {
  id: number;
  title: string;
  body: string;
  status: string;
}

export const fetchActivePolicies = async (
  baseUrl: string,
): Promise<PolicyItem[]> => {
  const res = await fetch(`${baseUrl}/admin/settings/policies/active`);
  const result = await res.json();

  if (result.success) {
    return result.data || [];
  }

  return [];
};

export const findPolicyByTitle = (
  policies: PolicyItem[],
  title: string,
): PolicyItem | undefined => {
  return policies.find(
    (item) => item.title?.trim().toLowerCase() === title.trim().toLowerCase(),
  );
};